import Layers from "slotworks/graphics/layers/layers";
import AbstractStepperControl from "slotworks/smart-ui/controls/abstract/abstract-stepper-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class AutoplayCountStepperControl extends AbstractStepperControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.stepperComponent.onUpdate.add(this.onStepperUpdated);
    }

    public updateOptions(options: ControlOptions) {
        if (!this.setupData) {
            this.setupValues(options.autoplays.values, options.autoplays.currentValue);
            this.setupData = true;
        } else {
            this.setSelectedValue(options.autoplays.currentValue);
        }

        this.setValueVisible(!options.customAutoplayCountSelected);
    }

    private onStepperUpdated = (value: number) => {
        const options = new ControlOptions();
        options.autoplays.currentValue = value;
        options.customAutoplayCountSelected = false;

        this.onChange.dispatch(options);
    }
}
